import React, { useState, useEffect } from 'react';
import Pagination from '../Common/Pagination';

const QA = (props) => {
    const getFormattedDate = (date) => {
        return date.toISOString().split('T')[0];
    };

    const [dateFr, setDateFr] = useState(getFormattedDate(new Date(new Date().setMonth(new Date().getMonth() - 1))));
    const [dateTo, setDateTo] = useState(getFormattedDate(new Date()));
    const [isChecked, setIsChecked] = useState(false);
    const [listData, setListData] = useState([]);
    const [filteredListData, setFilteredListData] = useState([]);
    const [errorMessage, setErrorMessage] = useState("");
    const [expandedPaths, setExpandedPaths] = useState({});
    const [currentPages, setCurrentPages] = useState({}); // key: QAStatus, value: currentPage

    useEffect(() => {
        getDocumentQAList();
    }, []);

    useEffect(() => {
        if (!isChecked) {
            setFilteredListData(listData.filter(item => item.qaStatus === '3'));
        } else {
            setFilteredListData(listData.filter(item => item.postPath === '[""]' && item.qaStatus === '3'));
        }
    }, [isChecked, listData]);

    const handleCheckboxChange = (event) => {
        setIsChecked(event.target.checked);
    };

    const toggleExpand = (index) => {
        setExpandedPaths(prevState => ({
            ...prevState,
            [index]: !prevState[index]
        }));
    };

    const getLastDayOfMonth = (year, month) => new Date(year, month, 0).getDate();

    const parseDateInput = (input) => {
        input = input.replace(/[^0-9]/g, '');

        if (input.length > 8) return "잘못된 날짜입니다.";

        const currentYear = new Date().getFullYear().toString();
        const currentMonth = (new Date().getMonth() + 1).toString().padStart(2, '0');

        const getYear = (inputLength) => {
            if (inputLength === 5) return `${currentYear.slice(0, 3)}${input[0]}`;
            if (inputLength === 6) return `${currentYear.slice(0, 2)}${input.slice(0, 2)}`;
            if (inputLength === 7) return `${currentYear.slice(0, 1)}${input.slice(0, 3)}`;
            return currentYear;
        };

        let year, month, day;

        switch (input.length) {
            case 1:
            case 2:
                year = currentYear;
                month = currentMonth;
                day = input.padStart(2, '0');
                break;
            case 3:
                year = currentYear;
                month = input[0].padStart(2, '0');
                day = input.slice(1, 3);
                break;
            case 4:
                year = currentYear;
                month = input.slice(0, 2);
                day = input.slice(2, 4);
                break;
            case 5:
            case 6:
            case 7:
                year = getYear(input.length);
                month = input.slice(input.length - 4, input.length - 2);
                day = input.slice(input.length - 2);
                break;
            case 8:
                year = input.slice(0, 4);
                month = input.slice(4, 6);
                day = input.slice(6, 8);
                break;
            default:
                return null;
        }

        const parsedYear = parseInt(year, 10);
        const parsedMonth = parseInt(month, 10);
        const parsedDay = parseInt(day, 10);
        const lastDay = getLastDayOfMonth(parsedYear, parsedMonth);

        if (parsedMonth < 1 || parsedMonth > 12 || parsedDay < 1 || parsedDay > lastDay) return "잘못된 날짜입니다.";

        return `${parsedYear}-${month}-${day}`;
    };

    const handleBlur = (setter, value) => {
        setErrorMessage("");
        const result = parseDateInput(value);
        if (typeof result === "string" && result.includes("잘못")) {
            setErrorMessage(result);
        } else if (result) {
            setter(result);
        }
    };

    const getDocumentQAList = () => {
        fetch(`api/Manager/GetDocumentQAList`, {
            method: 'POST',
            headers: {
                'Accept': 'application/json',
                'Content-Type': 'application/json; charset=utf-8'
            },
            body: JSON.stringify({
                dateFr: dateFr.replace(/-/g, ""),
                dateTo: dateTo.replace(/-/g, "")
            })
        }).then((response) => response.json())
            .then(resultData => {
                setListData(resultData.table);
            });
    };

    const renderCheckList = (listTitle, qaStatus) => {
        let rows;
        const pageCount = 10;
        const itemList = qaStatus === '3' ? filteredListData : listData.filter(item => item.qaStatus === qaStatus);
        const itemCount = itemList.length;
        const paginations = Math.ceil(itemCount / pageCount);

        const currentPage = currentPages[qaStatus] || 1;
        const startIdx = (currentPage - 1) * pageCount;
        const endIdx = startIdx + pageCount;
        const pagedList = itemList.slice(startIdx, endIdx);

        const renderTableRow = (item, index) => {
            const paths = JSON.parse(`[${item.postPath}]`);
            const pathLength = paths.length;
            const isExpanded = expandedPaths[index];
            const links = JSON.parse(item.postLink);

            return (
                <tr key={index}>
                    <td onClick={() => window.open(`/Manager/QAEditor/${item.qaid}`, "_blank")}>{item.title}</td>
                    <td>{new Date(item.updateDateTime).toISOString().split('T')[0]}</td>
                    <td>{item.devUserName}</td>
                    <td>{item.docBoxName}</td>
                    <td>{item.info === ' / ' ? '' : item.info}</td>
                    <td>{JSON.parse(item.requestPath).join(' > ')}</td>
                    <td>{item.qaTitle}</td>
                    <td>{item.comment}</td>
                    <td>
                        {pathLength > 1 && (
                            <div className="path-count-wrap">
                                <p className='path-count'>총 {pathLength}건</p>
                                <button className={`path-count-dropdown ${isExpanded ? 'expand' : ''}`} onClick={() => toggleExpand(index)}>
                                    <i className='icoKdc12 dropdown-g'></i>
                                </button>
                            </div>
                        )}
                        <div class="qa-path-wrap">
                            {paths.map((arr, i) => (
                                (isExpanded || i === 0) && (
                                    <span className="qa-path" key={i} onClick={() => window.open(`/${links[i]}`, '_blank')}>
                                        {arr.join(' > ')}
                                        <br />
                                    </span>
                                )
                            ))}
                        </div>
                    </td>
                </tr>
            );
        };

        const setCurrentPage = (page) => {
            setCurrentPages(prev => ({ ...prev, [qaStatus]: page }));
        };

        const setPaging = (dir) => {
            const newPage = dir === 'prev' ? Math.max(1, currentPage - 1) : Math.min(paginations, currentPage + 1);
            setCurrentPage(newPage);
        };

        rows = pagedList.map(renderTableRow);

        return (
            <div className="check-list">
                <div className="check-title-wrap">
                    <div className="check-title">
                        <h2 className="list-title">{listTitle}</h2>
                        <h4 className="count">{itemCount}</h4>
                    </div>
                    {
                        listTitle === '검수완료' && (
                            <div className="toggle-button-cover">
                                <div className="button-cover">
                                    <div className="button b2" id="button-10">
                                        <input
                                            type="checkbox"
                                            className="checkbox"
                                            checked={isChecked}
                                            onChange={handleCheckboxChange}
                                        />
                                        <div className="knobs">
                                            <span>전체</span>
                                        </div>
                                        <div className="layer"></div>
                                    </div>
                                </div>
                            </div>
                        )
                    }
                </div>
                <section className="list-layout">
                    <div className="list-wrap">
                        <table className="list doc-check">
                            <thead>
                                <tr>
                                    <th>제목</th>
                                    <th>요청일</th>
                                    <th>작성자</th>
                                    <th>문서함</th>
                                    <th>요청제품 및 버전</th>
                                    <th>요청경로</th>
                                    <th>요청 메뉴명</th>
                                    <th>요청 코멘트</th>
                                    <th>게시경로</th>
                                </tr>
                            </thead>
                            <tbody>
                                {rows}
                            </tbody>
                        </table>
                    </div>
                </section>
                <Pagination totalCount={itemCount} pageCount={pageCount} currentPage={currentPage} setCurrentPage={setCurrentPage} setPaging={setPaging} />
            </div>
        );
    };

    return (
        <div className="content-scroll">
            <div className="filter-bar">
                <div className="period-filter">
                    <p>조회기간</p>
                    <div className="period-input-wrap">
                        <input
                            type="text"
                            className="period-date"
                            value={dateFr}
                            onChange={(e) => setDateFr(e.target.value.replace(/[^0-9-]/g, ''))}
                            onBlur={() => handleBlur(setDateFr, dateFr)}
                            placeholder="시작일"
                            maxLength="10"
                        />
                        <p>~</p>
                        <input
                            type="text"
                            className="period-date"
                            value={dateTo}
                            onChange={(e) => setDateTo(e.target.value.replace(/[^0-9-]/g, ''))}
                            onBlur={() => handleBlur(setDateTo, dateTo)}
                            placeholder="종료일"
                            maxLength="10"
                        />
                    </div> 
                    {errorMessage && <p className="error-message" style={{ color: 'red' }}>{errorMessage}</p>}
                    <button className="btn-inquiry" onClick={() => getDocumentQAList()}>조회</button>
                </div>
            </div>
            <div className="content-inspect">
                {props.type === "progress" ? (
                    <>
                        {renderCheckList("검수요청", '1')}
                        {renderCheckList("검수중", '2')}
                    </>
                ) : (
                    <>
                        {renderCheckList("검수완료", '3')}
                        {renderCheckList("반려", '4')}
                    </>
                )}
            </div>
        </div>
    );
}

export default QA;